<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-product-list" class="ag-grid-container">
    <div class="vx-card">
      <grid-panel
          :column-defs="columnDefs"
          height="xl"
          :url="() => this.$api.productBundles.list()"
          ref="grid"
          :auto-size="true"
          @rowClicked="edit"
          title="Product Bundles"
      >
        <vs-dropdown-item class="create-product-bundle-action" v-if="componentAccess.canCreate.access">
          <span
              class="flex items-center"
              @click="$router.push({ name: 'product-bundles.create' })"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Create Product Bundle</span>
          </span>
        </vs-dropdown-item>
      </grid-panel>

    </div>
  </div>
</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import CellRendererVerified from "@/views/components/ag-grid/cell-renderer/CellRendererVerified";

export default {
  components: {
    TGrid,
    GridPanel,
    CellRendererVerified,
  },
  mixins: [CellMatchingMixin, CanAccessMixin],
  data () {
    return {
      searchQuery: '',
      componentAccess: {
        canCreate: {
          route: 'product-bundles.create',
          access: false,
        },
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'Orion Bundle Name',
          field: 'OrionBundleName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'ORA Bundle Name',
          field: 'ORABundleName',
          filter: 'agTextColumnFilter',
        },
      ],
    }
  },
  methods: {
    edit({data}) {
      this.$router.push({ name: 'product-bundles.view', params: { id: data.id }}).catch(() => {});
    }
  },
}

</script>

<style lang="scss">
</style>
